<template>
  <header class="app-header"
    :class="{ 'app-header--scrolled': isHeaderScrolled, 'detect_deviece_mobile': deviceType === 'mobile' }">
    <div class="app-header__left">
      <div class="app-header__logo" @click="goToHome">
        <span class="app-header__logo-text">Velocifyx</span>
      </div>
      <nav class="app-header__nav" v-if="deviceType === 'desktop' || deviceType === 'pc'">
        <div v-for="(item, index) in navItems" :key="index" @click="handleNavClick(item)"
          class="app-header__nav-item-wrapper"
          :class="{ 'app-header__nav-item--active': isRouteActive(item.link) }">
          <div class="app-header__nav-item">
            {{ item.name }}
          </div>
        </div>
      </nav>
    </div>

    <!-- PC & Tablet Navigation -->
    <div class="app-header__right" v-if="deviceType === 'desktop' || deviceType === 'pc'">
      <div class="app-header__contact-btn" @click="handleNavClick({ link: '/#footer-section' })">
        Contact Us
      </div>
    </div>

    <!-- Mobile Navigation -->
    <div v-if="deviceType === 'mobile'">
      <div class="app-header__mobile-trigger" @click="toggleMobileMenu">
        <img v-if="!showMobileMenu"
          :src="isHeaderScrolled ? require('@/assets/mobile-menu-dark.svg') : require('@/assets/mobile-menu.svg')"
          alt="menu" />
        <img v-else src="@/assets/clos-menu.svg" alt="close menu" class="app-header__close-icon" />
      </div>

      <div class="app-header__mobile-overlay" v-if="showMobileMenu" @click="toggleMobileMenu"></div>
      <div class="app-header__mobile-menu" v-if="showMobileMenu">
        <div class="app-header__mobile-menu-header">
          <div class="app-header__logo" @click="goToHome">
            <span class="app-header__logo-text">Velocifyx</span>
          </div>
          <div class="app-header__mobile-trigger" @click="toggleMobileMenu">
            <img src="@/assets/clos-menu.svg" alt="close menu" class="app-header__close-icon" />
          </div>
        </div>
        <div v-for="(item, index) in navItems" :key="index" @click="handleNavClick(item)"
          class="app-header__mobile-menu-item">
          {{ item.name }}
          <img src="@/assets/default/nav-arrow.svg" alt=">" />
        </div>
        <div class="app-header__mobile-contact-btn"
          @click="handleNavClick({ link: '/#footer-section' })">
          Contact Us
          <img src="@/assets/banner-contact-arrow.svg" alt=">" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppHeader',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig'
    }),
    isHeaderScrolled () {
      return this.isScrolled || this.$route.path.startsWith('/about') || this.$route.path.startsWith('/services');
    }
  },
  data () {
    return {
      showMobileMenu: false,
      isScrolled: false,
      scrollThreshold: 10,
      navItems: [
        { name: 'Home', link: '/' },
        { name: 'About Us', link: '/about' },
        { name: 'Services', link: '/services' },
      ]
    };
  },
  watch: {
    showMobileMenu (isOpen) {
      const overflowValue = isOpen ? 'hidden' : '';
      document.body.style.overflow = overflowValue;
      document.documentElement.style.overflow = overflowValue;
    }
  },
  methods: {
    handleNavClick (item) {
      this.showMobileMenu = false;
      this.$router.push(item.link).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
    toggleMobileMenu () {
      this.showMobileMenu = !this.showMobileMenu;
    },

    // 判断当前路由是否激活
    isRouteActive (link) {
      // 获取不包含channel参数的当前路径
      let currentPath = this.$route.path;
      const channel = this.$route.params.channel;

      // 如果存在channel参数，移除channel部分以便正确比较
      if (channel && currentPath.startsWith(`/${channel}`)) {
        currentPath = currentPath.replace(`/${channel}`, '') || '/';
      }

      // 处理根路径特殊情况
      if (link === '/' && (currentPath === '/' || currentPath === '')) {
        return true;
      }

      // 其他情况检查路径是否匹配（排除根路径情况）
      if (link !== '/') {
        return currentPath.startsWith(link);
      }

      return false;
    },

    goToHome () {
      if (this.$route.path === '/') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        window.location.href = `/${this.$route.params.channel}`;
      } else {
        // 保留查询参数
        this.$router.push({
          path: '/',
        });
      }
    },

    // 处理滚动事件
    handleScroll () {
      if (typeof window !== 'undefined') {
        this.isScrolled = window.scrollY > this.scrollThreshold;
      }
    }
  },
  beforeDestroy () {
    // 确保在组件销毁时恢复body和html滚动
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    // 移除滚动事件监听
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  mounted () {
    // 监听路由变化，关闭移动菜单
    this.$router.afterEach(() => {
      if (this.showMobileMenu) {
        this.showMobileMenu = false;
        document.body.style.overflow = '';
      }
    });

    // 添加滚动事件监听
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll);
      // 初始化滚动状态
      this.handleScroll();
    }
  }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.app-header {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 100;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	height: rem(68);
	padding: 0 rem(180);
	transition: background-color 0.3s ease, box-shadow 0.3s ease;

	&__left {
		display: flex;
		align-items: center;
		gap: rem(72);
	}

	&__logo {
		cursor: pointer;
	}

	&__logo-text {
		font-size: rem(28);
		font-weight: 700;
		display: block;
		line-height: rem(28);
		color: #ffffff;
		text-transform: uppercase;
	}

	&__nav {
		display: flex;
		align-items: center;
		gap: rem(52);
		height: rem(68);
	}

	&__nav-item-wrapper {
		display: flex;
		align-items: center;
		height: 100%;
		border-bottom: 4px solid transparent;
		box-sizing: border-box;
		cursor: pointer;
		transition: border-color 0.3s ease;
	}

	&__nav-item {
		font-size: rem(16);
		font-weight: 400;
		line-height: rem(16);
		color: #ffffff;
		text-decoration: none;
		transition: color 0.3s ease;
		padding: 0 rem(4);
	}

	&__nav-item-wrapper:hover {
		border-bottom-color: #473bf0;
	}

	&__nav-item--active {
		border-bottom-color: #473bf0;
		.app-header__nav-item {
			font-weight: 700;
		}
	}

	&__contact-btn {
		background: #473bf0;
		border-radius: 8px;
		padding: rem(12) rem(24);
		color: #ffffff;
		font-size: rem(16);
		font-weight: 700;
		line-height: rem(16);
		cursor: pointer;
		transition: all 0.3s ease;
		&:hover {
			transform: translateY(-4px);
		}
	}

	&__mobile-trigger {
		cursor: pointer;
		z-index: 1001;
		img {
			width: rem(32);
			height: rem(32);
		}
	}

	&__close-icon {
		width: rem(24) !important;
		height: rem(24) !important;
	}

	&__mobile-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		z-index: 998;
	}

	&__mobile-menu {
		position: fixed;
		top: 0;
		right: 0;
		width: 100%;
		height: 100vh;
		background: #ffffff;
		z-index: 999;
		padding: 0 rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(16);

		&-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: rem(68);
			.app-header__logo-text {
				color: #161c2d;
			}
		}
	}
	&__mobile-menu-item {
		border-left: rem(4) solid #473bf0;
		background: linear-gradient(90deg, rgba(71, 59, 240, 0.16) 0%, rgba(71, 59, 240, 0.04) 100%);
	}

	&__mobile-menu-item,
	&__mobile-contact-btn {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: rem(16) rem(24);
		background: #f4f7fa;
		border-radius: rem(8);
		font-size: rem(16);
		font-weight: 700;
		color: #161c2d;
		cursor: pointer;

		img {
			width: rem(16);
			height: rem(16);
		}
	}

	&__mobile-contact-btn {
		background: #473bf0;
		color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: rem(16);
	}

	&.detect_deviece_mobile {
		padding: 0 rem(16);
		height: rem(68);

		.app-header {
			&__mobile-menu {
				&-header {
					margin-bottom: rem(16);
				}
			}
		}
	}

	&--scrolled {
		position: fixed;
		background-color: #ffffff;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		.app-header__logo-text,
		.app-header__nav-item {
			color: #161c2d;
		}
	}
}
</style>

